import { matchesRoutePrefixes, normalizeComparisonValue } from "@/components/ChatWidgetVisibilityManager/utils";

export type StarterChipGroup = "bank" | "forms" | "payments" | "settings" | "serviceEntry" | "default";

const STARTER_CHIP_GROUP_PREFIXES: ReadonlyArray<{
  group: Exclude<StarterChipGroup, "default">;
  prefixes: readonly string[];
}> = [
  { group: "bank", prefixes: ["/o/bank", "/o/stripe-onboarding"] },
  { group: "forms", prefixes: ["/o/donations/forms", "/o/tickets/forms", "/o/fundraising"] },
  { group: "payments", prefixes: ["/o/all-payments"] },
  { group: "settings", prefixes: ["/o/settings", "/o/crm"] },
  { group: "serviceEntry", prefixes: ["/o/forms/new"] },
];

export const getStarterChipGroup = (pathWithoutLocale: string): StarterChipGroup => {
  const path = normalizeComparisonValue(pathWithoutLocale);
  return STARTER_CHIP_GROUP_PREFIXES.find(({ prefixes }) => matchesRoutePrefixes(path, prefixes))?.group ?? "default";
};
